import React from 'react'
import { colors } from 'app-v2/design-systems/theme/colors'
import { useIntl } from 'react-intl'
import { AnchorButton } from 'app-v2/design-systems/components/inputs/button/Button'
import styled from 'styled-components'

export const Legals = () => {
    const intl = useIntl()
    return (
        <StyledLegalsContainer>
            <StyledButtonContainer>
                <AnchorButton
                    target={'_blank'}
                    href={intl.formatMessage({
                        id: 'routes.tupreferesking.legals'
                    })}
                    otherStyle={{ alignSelf: 'center' }}
                    buttonColor={colors.bbqBrown}
                    labelColor={colors.bbqBrown}
                    variant={'outlined'}>
                    {intl.formatMessage({
                        id: 'tupreferesking.home.legals.see-rules'
                    })}
                </AnchorButton>
            </StyledButtonContainer>
        </StyledLegalsContainer>
    )
}

const StyledLegalsContainer = styled.div`
    padding: 24px 0;
`

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`
